import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "TU_API_KEY_AQUÍ", 
  authDomain: "estadoandresherrera.firebaseapp.com",
  projectId: "estadoandresherrera",
  storageBucket: "estadoandresherrera.appspot.com",
  messagingSenderId: "305282245053",
  appId: "1:305282245053:web:644a43a0d1645e7514f04c"
};

const app = initializeApp(firebaseConfig);
// ESTA ES LA LÍNEA QUE BUSCAN LOS OTROS ARCHIVOS
export const db = getFirestore(app);